export type RizeSessionType =
	| 'focus'
	| 'meeting'
	| 'break'

export const RizeSessionTypes: RizeSessionType[] = [
	'focus',
	'meeting',
	'break'
]

export type RizeMasterType = 'rize'